export function get(
  object: Record<string, any>,
  keys: string | string[],
  defaultVal?: any,
): any {
  keys = Array.isArray(keys) ? keys : keys.split('.');
  object = object?.[keys[0]];
  if (object && keys.length > 1) {
    return get(object, keys.slice(1), defaultVal);
  }
  return object === undefined ? defaultVal : object;
}

export const stopEvent = (e: React.UIEvent) => {
  e.stopPropagation();
  e.preventDefault();
};

export const uniq = (arr: any[]) => [...new Set(arr)];

export const isNumber = (num: any): num is number =>
  !Number.isNaN(+num) && Number.isFinite(+num);

export const noop = (...params: any) => undefined;

/**
 * Applies international rounding to a number with more than two decimal places.
 * If the third decimal digit is less than 5, keeps the second decimal unchanged.
 * If the third decimal digit is 5 or greater, increases the second decimal by 1.
 *
 * @param num - The number to round
 * @returns The number rounded to 2 decimal places using international rounding
 */
export const roundInternational = (num: number): number => {
  if (!isNumber(num)) {
    return 0;
  }

  // Convert to string to examine decimal places
  const numStr = num.toString();
  const decimalIndex = numStr.indexOf('.');

  // If no decimal point or less than 3 decimal places, return as is rounded to 2 decimals
  if (decimalIndex === -1 || numStr.length <= decimalIndex + 3) {
    return Math.round(num * 100) / 100;
  }

  // Get the third decimal digit
  const thirdDecimal = parseInt(numStr[decimalIndex + 3], 10);

  // Apply international rounding logic
  if (thirdDecimal < 5) {
    // Truncate to 2 decimal places
    return Math.floor(num * 100) / 100;
  } else {
    // Round up to 2 decimal places
    return Math.ceil(num * 100) / 100;
  }
};

const nilTypes = [undefined, null];

export const isNil = (arg: any): arg is (typeof nilTypes)[number] =>
  nilTypes.includes(arg);
